import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kmToMiles'
})
export class KmToMilesPipe implements PipeTransform {

  transform(value: number): number {
    // Conversion from km to miles
    const kmToMilesFactor = 0.621371; // 1 km is 0.621371 miles
    const convertedValue = value * kmToMilesFactor;
    
    return convertedValue /* >= 0 ? Math.floor(convertedValue) : Math.ceil(convertedValue) */;
  }

}
